<mat-chip-list>
	<mat-chip
		*ngFor="let sub of array.controls; let i = index"
		[color]="sub.value.isPrimary ? 'primary' : 'secondary'"
		[matTooltip]="sub.value.isPrimary ? 'Primary Contact' : ''"
		selected
		(click)="editPhoneNumber(i)"
	>
		{{ sub.value.areaCode + sub.value.number | phone }}
		<mat-icon
			matChipRemove
			rpsharedConfirm="Delete phone number?"
			(onConfirmed)="array.removeAt(i)"
			>cancel</mat-icon
		>
	</mat-chip>
	<mat-chip
		color="primary"
		class="add-phone-number-chip"
		(click)="addPhoneNumber()"
		>Add
		<mat-icon matChipRemove>add</mat-icon>
	</mat-chip>
</mat-chip-list>
